const demo_app = {
    notification: 'Tipp: Erstelle zuerst ein Konto, um die Anmeldeerfahrung zu testen.',
};
export default Object.freeze(demo_app);
